import { Dropdown } from 'antd';
import { Bell } from 'react-feather';
import AppHeaderButton from '@/components/_common/AppHeaderButton';
import NotificationsDropdownOverlay from '../NotificationsDropdownOverlay';
import { useState } from 'react';
import {
  useUserNotificationListFilter,
  useUserNotificationMarkAsRead,
} from '@/core/domain/communication/userNotification/userNotification.hooks';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import moment from 'moment';
import { getAuthCodeAndRedirect } from '@/utils/functions/getAuthCodeAndRedirect';
import ModalLoadingOverlay from '@/components/_common/ModalLoadingOverlay';
import { useNotificationHubConfig } from '@/contexts/WebsocketProvider/Notification.config';
import { useNotification } from '@/contexts/WebsocketProvider/Notification.provider';

const NotificationsDropdownMenu = () => {
  const { notificationCount } = useNotification();

  const notificationConfig = useNotificationHubConfig();

  const [isRead, setIsRead] = useState(false);
  const [generateCode, setGenerateCode] = useState(false);

  const notificationFilter = useUserNotificationListFilter({ isRead });
  const notificationMarkAsRead = useUserNotificationMarkAsRead();

  const notifications = flatInfiniteData(notificationFilter.data);

  const notificationRedirect = async (options: {
    redirectUrl: string;
    userNotificationid: number;
  }) => {
    const url = new URL(options.redirectUrl);

    await notificationMarkAsRead.mutateAsync({
      userNotificationIds: [options.userNotificationid],
    });

    if (url.host === window.location.host) {
      window.location.href = options.redirectUrl;
    } else if (!url.href.includes(process.env.REACT_APP_GP_URL || '')) {
      window.open(options.redirectUrl, '_blank');
    } else {
      setGenerateCode(true);
      await getAuthCodeAndRedirect(options.redirectUrl, '_blank', {
        destinationUrl: url.origin + '/auth-code',
      });
      setGenerateCode(false);
    }
  };

  return (
    <>
      <Dropdown
        placement="bottomRight"
        trigger={['click']}
        overlay={
          <NotificationsDropdownOverlay
            dataSource={notifications.map((item) => ({
              date: moment(item.createdAt).fromNow(),
              title: item.message,
              description: item.description,
              wasRead: item.isRead,
              onClick: () => {
                if (item.redirectUrl) {
                  notificationRedirect({
                    redirectUrl: item.redirectUrl,
                    userNotificationid: item.userNotificationId,
                  });
                }
              },
            }))}
            isRead={isRead}
            onFilter={setIsRead}
            enableNotification={notificationConfig.balloonEnabled}
            enableAudio={notificationConfig.audioEnabled}
            toggleNotification={notificationConfig.toggleBalloon}
            toggleAudio={notificationConfig.toggleAudio}
            loadMore={notificationFilter.fetchNextPage}
            hasMore={!!notificationFilter.hasNextPage}
            isLoading={notificationFilter.isFetching}
          />
        }
      >
        <AppHeaderButton icon={<Bell />} countBadge={notificationCount} />
      </Dropdown>

      {generateCode && (
        <ModalLoadingOverlay
          messages={['gerando código de redirecionamento...']}
        />
      )}
    </>
  );
};

export default NotificationsDropdownMenu;
